import {
  Embelishment,
  Embelishment_Right,
  Galaktika_BG,
} from '../../assets/img'
import Galaktika_Button from '../../assets/img/Galaktika_Enter_The_Council.png'
import { clearLocal } from '../../utilities/clearLocal'
import Head from '../containers/Head'

const SecondaryLayout = ({ children, pageTitle, secondaryTitle }) => {
  const mainStyle = {
    backgroundImage: `url(${Galaktika_BG})`,
  }

  const embelishment = {
    backgroundImage: `url(${Embelishment})`,
  }

  const embelishmentRight = {
    backgroundImage: `url(${Embelishment_Right})`,
    backgroundPosition: 'right',
  }

  return (
    <main
      className="flex flex-col items-center bg-cover bg-center h-[140vh]"
      style={mainStyle}
    >
      <Head />
      <div className=" w-4/5 flex justify-between relative">
        <div className="lg:w-1/3">
          <h1 className="text-cyanBlue pl-3 uppercase">{pageTitle}</h1>
          <div
            className="bg-contain h-10 xl:h-14 -mt-2 -mb-5 -ml-28 bg-no-repeat hidden lg:block"
            style={embelishment}
          ></div>
        </div>

        <div className="hidden lg:inline w-1/3">
          {secondaryTitle}
          <div
            className="bg-contain h-10 xl:h-14 -mt-2 -mb-5 -mr-28 bg-no-repeat hidden lg:block"
            style={embelishmentRight}
          ></div>
        </div>
      </div>
      {children}
    </main>
  )
}

export default SecondaryLayout
